import { createFileRoute } from "@tanstack/react-router";
import { AppUpdatePage } from "@/components/dashboard/app-update-page";

export const Route = createFileRoute("/app-update")({
  head: () => ({
    meta: [
      { title: "App update — Deuxda Admin" },
      { name: "description", content: "Set the minimum app version users must install." },
    ],
  }),
  component: () => <AppUpdatePage />,
});
